import apiAxios from '@/services/axiosConfig';
import type { TestConnectionResponse } from '@/types/api';

async function testConnection(uuid: string): Promise<TestConnectionResponse> {
  const response = await apiAxios.get<TestConnectionResponse>(`/api/v1/mt/connections/${uuid}/test`);
  return response.data;
}

export default testConnection;
